import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import Header from './components/Header'
import Footer from './components/Footer'

// Public pages
import ProductList from './pages/public/ProductList'
import RedeemFlow from './pages/public/RedeemFlow'
import RedeemStatus from './pages/public/RedeemStatus'
import Receipt from './pages/public/Receipt'

// Admin pages
import AdminLogin from './pages/admin/Login'
import AdminDashboard from './pages/admin/Dashboard'
import AdminProducts from './pages/admin/Products'
import AdminCodes from './pages/admin/Codes'
import AdminRedemptions from './pages/admin/Redemptions'
import AdminAuditLog from './pages/admin/AuditLog'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth()
  return isAuthenticated ? children : <Navigate to="/co/login" replace />
}

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Header isAdmin />
      <div className="container mx-auto px-4 py-8">
        {children}
      </div>
    </div>
  )
}

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={
        <PublicLayout>
          <ProductList />
        </PublicLayout>
      } />
      
      <Route path="/redeem" element={
        <PublicLayout>
          <RedeemFlow />
        </PublicLayout>
      } />
      <Route path="/redeem/:category" element={
        <PublicLayout>
          <RedeemFlow />
        </PublicLayout>
      } />
      
      <Route path="/status/:redemptionId" element={
        <PublicLayout>
          <RedeemStatus />
        </PublicLayout>
      } />
      <Route path="/receipt/:token" element={
        <PublicLayout>
          <Receipt />
        </PublicLayout>
      } />

      {/* Admin login */}
      <Route path="/co/login" element={
        <div className="min-h-screen bg-background">
          <AdminLogin />
        </div>
      } />

      {/* Protected admin routes */}
      <Route path="/co" element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminDashboard />
          </AdminLayout>
        </ProtectedRoute>
      } />

      <Route path="/co/products" element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminProducts />
          </AdminLayout>
        </ProtectedRoute>
      } />

      <Route path="/co/codes" element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminCodes />
          </AdminLayout>
        </ProtectedRoute>
      } />

      <Route path="/co/redemptions" element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminRedemptions />
          </AdminLayout>
        </ProtectedRoute>
      } />

      <Route path="/co/audit" element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminAuditLog />
          </AdminLayout>
        </ProtectedRoute>
      } />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App